import { FC, Suspense, useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { UserContext } from '../providers/UserContext';
import { AIProvider } from '../providers/AIProvider';
import Agent from './agents/Agent';
import MappingReviewPanel from './agents/review/MappingReviewPanel';
import { KeyboardHost } from '@/keyboard';

const ProtectedRoute: FC = () => {
  const userContext = useContext(UserContext);
  const location = useLocation();

  if (userContext.loading) {
    return <Spin size="large" fullscreen />;
  }

  if (!userContext.isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <AIProvider>
      <Suspense fallback={<Spin size="large" fullscreen />}>
        <Outlet />
      </Suspense>
      <KeyboardHost />
      {userContext.userRights.aiAgent && (
        <>
          <MappingReviewPanel />
          <Agent />
        </>
      )}
    </AIProvider>
  );
};

export default ProtectedRoute;
